module.exports = __webpack_public_path__ + "img/huauchinango.439597fd.jpg";